import { useState } from 'react';
import { Placement } from '@noths/polaris-client-ribbons-design-system';
import { useRichRelevance } from '@noths/polaris-client-rich-relevance';
import getConfig from 'next/config';

import { NextConfig } from 'src/types/NextConfig';
import { ProductPlacement } from 'src/types/RecentlyViewed';

const { publicRuntimeConfig } = getConfig() as NextConfig;

export const HOMEPAGE_WITHOUT_PLACEMENT = 'home_page';

export interface UseHomepageRichRelevanceDataOptions {
  placementType: Placement | typeof HOMEPAGE_WITHOUT_PLACEMENT | null;
  sessionId?: string;
  hasDisabledCookies: boolean;
}

export const useHomepageRichRelevanceData = ({
  placementType,
  sessionId,
  hasDisabledCookies,
}: UseHomepageRichRelevanceDataOptions) => {
  const [richRelevanceData, setRichRelevanceData] = useState<ProductPlacement | undefined>();

  useRichRelevance(
    {
      API_KEY: publicRuntimeConfig.RICH_RELEVANCE_API_KEY,
      endpoint: publicRuntimeConfig.RICH_RELEVANCE_URL,
      sessionId,
      hasDisabledCookies,
    },
    async (fetchPlacement, clearPlacement) => {
      if (!placementType) {
        return;
      }

      window.R3_COMMON.addPlacementType(placementType);
      window.R3_HOME = new window.r3_home();

      if (placementType !== HOMEPAGE_WITHOUT_PLACEMENT) {
        await fetchPlacement();

        /* istanbul ignore next */
        const placement = window.RR?.data?.JSON?.placements?.[0];

        if (placement) {
          setRichRelevanceData(placement);
        }

        clearPlacement();
      }
    },
  );

  return richRelevanceData;
};
